import { __decorate, __metadata } from "tslib";
import { Expose, IsBoolean, Model, ModelId } from '@core/shared/model';
import { AppRequestMethod } from '@core/shared/request';
import { AppRequest } from '@core/shared/app-request';
let UpdateTrackingConsentRequest = /*#__PURE__*/(() => {
  let UpdateTrackingConsentRequest = class UpdateTrackingConsentRequest extends Model {};
  __decorate([Expose(), IsBoolean(), __metadata("design:type", Boolean)], UpdateTrackingConsentRequest.prototype, "consent", void 0);
  UpdateTrackingConsentRequest = __decorate([AppRequest('tracking', 'update-consent', {
    httpMethod: AppRequestMethod.POST
  }), ModelId("UpdateTrackingConsentRequest") // auto-generated by generate-model-ids
  ], UpdateTrackingConsentRequest);
  return UpdateTrackingConsentRequest;
})();
export { UpdateTrackingConsentRequest };